<script>
import { useAlert } from 'dashboard/composables';
import { mapActions, mapGetters } from 'vuex';
import { apiErrorMessage } from '../../../../api/coLiving/errors';
import { CARD_CLASS, SELECT_CLASS } from '../constants';

// Who receives visit, failure and unregistered-sender alerts: one role, kept
// in the settings resource as `ops_role_key` (null clears it).
export default {
  name: 'OpsRoleCard',
  data() {
    return {
      cardClass: CARD_CLASS,
      selectClass: SELECT_CLASS,
      roleKey: '',
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters('coLivingConfig', { settings: 'getSettings' }),
    ...mapGetters('coLivingCatalog', { activeRoles: 'getActiveRoles' }),
  },
  watch: {
    settings: {
      immediate: true,
      handler(settings) {
        if (settings) {
          this.roleKey = settings.ops_role_key || '';
        }
      },
    },
  },
  methods: {
    ...mapActions('coLivingConfig', ['saveSettings']),
    async onSave() {
      this.isSaving = true;
      try {
        await this.saveSettings({ ops_role_key: this.roleKey || null });
        useAlert(this.$t('CO_LIVING.COMMON.SAVED'));
      } catch (err) {
        useAlert(apiErrorMessage(this, err, 'CO_LIVING.SETTINGS.SAVE_FAILED'));
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<template>
  <section :class="cardClass" data-testid="co-living-ops-role">
    <h2 class="text-lg font-medium text-slate-900 dark:text-slate-100">
      {{ $t('CO_LIVING.ROUTING.OPS.TITLE') }}
    </h2>
    <p class="mt-1 mb-4 text-sm text-slate-600 dark:text-slate-300">
      {{ $t('CO_LIVING.ROUTING.OPS.DESCRIPTION') }}
    </p>
    <form class="grid grid-cols-1 gap-4" @submit.prevent="onSave">
      <div>
        <label
          for="co-living-ops-role-select"
          class="block mb-1 text-sm text-slate-700 dark:text-slate-200"
        >
          {{ $t('CO_LIVING.ROUTING.OPS.LABEL') }}
        </label>
        <select
          id="co-living-ops-role-select"
          v-model="roleKey"
          :class="selectClass"
          data-testid="co-living-ops-role-select"
        >
          <option value="">{{ $t('CO_LIVING.COMMON.NONE') }}</option>
          <option v-for="role in activeRoles" :key="role.key" :value="role.key">
            {{ role.label }}
          </option>
        </select>
      </div>
      <div>
        <woot-button
          type="submit"
          :is-loading="isSaving"
          data-testid="co-living-ops-role-save"
        >
          {{ $t('CO_LIVING.COMMON.SAVE') }}
        </woot-button>
      </div>
    </form>
  </section>
</template>
